import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const $ = jQuery;

$(function () {
  // parallax dashed circles
  gsap.utils.toArray('.dashed-circle').forEach(section => {
    const step = section.closest('.step');
    gsap.fromTo(
      section,
      {
        y: '400px',
        opacity: 0.5,
      },
      {
        scrollTrigger: {
          trigger: step,
          scrub: true,
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
        y: 0,
        ease: 'none',
        opacity: 1,
      }
    );
  });

  // parallax ball
  gsap.utils.toArray('.ball').forEach(section => {
    const step = section.closest('.step');
    gsap.fromTo(
      section,
      {
        y: '-400px',
        scaleY: 0.8,
        opacity: 0.1,
        rotation: 0,
      },
      {
        scrollTrigger: {
          trigger: step,
          scrub: true,
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
        y: 0,
        scaleY: 1,
        opacity: 1,
        ease: 'none',
        rotation: 10,
      }
    );
  });

  // parallax circle
  gsap.utils.toArray('.circle').forEach(section => {
    const step = section.closest('.step');
    gsap.fromTo(
      section,
      {
        y: '-100px',
        opacity: 0.1,
      },
      {
        scrollTrigger: {
          trigger: step,
          scrub: true,
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
        y: 0,
        opacity: 1,
        ease: 'none',
      }
    );
  });
});
